import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
@Component({
  selector: 'app-addptaxmaindetails',
  templateUrl: './addptaxmaindetails.component.html',
  styleUrls: ['./addptaxmaindetails.component.css']
})
export class AddptaxmaindetailsComponent implements OnInit{


  constructor(private toastr: ToastrService, private appService: AppdataService,
    private loginService: LoginserviceService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) { }


  //Save Validation
  submitted: boolean;
  successfully: boolean;

  isduplicate: boolean;
  ptaxtypeColl:any=[];

  ptaxdetailsform = new FormGroup({
    ptaxdetid: new FormControl(0),
    ptaxtype: new FormControl(null, Validators.required),
    rangefrom: new FormControl(''),
    rangeto: new FormControl(''),
    taxamt: new FormControl(''),
    

  });




  @Input() ptaxdetid: any = 0;
  @Input() ptaxtype: any = '';
  @Input() rangefrom: any = '';
  @Input() rangeto: any  = '';
  @Input() taxamt: any  = '';
  @Input() ptaxdetailsColl: any = [];

  @Output() emitData = new EventEmitter();

  ngOnInit() {

    this.ptaxdetailsform.reset();
    this.fnInitializeFormGroup();
    this.fnGetTaxPeriod();
  }


  fnInitializeFormGroup() {
    this.ptaxdetailsform.setValue({
      ptaxdetid: this.ptaxdetid,
      ptaxtype: this.ptaxtype,
      rangefrom: this.rangefrom,
      rangeto: this.rangeto,
      taxamt: this.taxamt,
    })
  }
  
  fnGetTaxPeriod() {
    this.ptaxtypeColl.push({ value: 'BELOW', displayname: 'Below' });
    this.ptaxtypeColl.push({ value: 'ABOVE', displayname: 'Above' });
    this.ptaxtypeColl.push({ value: 'BETWEEN', displayname: 'Between' });
  }
 
  fnSaveBtnClick() {
    try {
      this.submitted = true;
      this.successfully = false;


      //Validate
      if (this.ptaxdetailsform.valid) {
        //Check
        var data = {
          ptaxdetid: this.ptaxdetid,
          ptaxtype: this.ptaxdetailsform.get('ptaxtype').value,
          rangefrom: this.ptaxdetailsform.get('rangefrom').value,
          rangeto: this.ptaxdetailsform.get('rangeto').value,
          taxamt: this.ptaxdetailsform.get('taxamt').value,
        }


        this.emitData.emit(data);
        this.activeModal.close(true);


      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }

}
